/**
 *   Copyright (C) Cylergie - All Rights Reserved
 * Proprietary and confidential
 * Subject to French law on copyright
 * Unauthorized copying of this file, via any medium is strictly prohibited: https://crigen.myengie.com/copyright
 * Any request for authorization of use should be addressed by email to"mvalo.bvt@engie.com" with the subject "Copyright Statement in Source Code"
 * Written in 2024
 */

/* eslint-disable */

import { OktaAuth } from '@okta/okta-auth-js';
import OktaVue from '@okta/okta-vue';
import getEnv from '@/utils/env';

// Create OktaAuth instance for Vue 3
const oktaAuth = new OktaAuth({
  issuer: getEnv('OKTA_ISSUER'),
  clientId: getEnv('OKTA_CLIENT_ID'),
  redirectUri: getEnv('OKTA_REDIRECT_URL'),
  scopes: ['openid', 'profile', 'email'],
  responseType: ['id_token'],
  pkce: true,
  tokenManager: {
    secure: true,
    storage: 'sessionStorage',
  },
});

console.log('[OKTA] Authentication configured with:', {
  issuer: getEnv('OKTA_ISSUER'),
  clientId: getEnv('OKTA_CLIENT_ID'),
  redirectUri: getEnv('OKTA_REDIRECT_URL'),
});

export { oktaAuth, OktaVue };
